import { GraphQLContentMapper } from './GraphQLContentMapper'
import { quizBlockMapper } from './blocks/QuizBlockMapper'

export const graphqlContentMapper = new GraphQLContentMapper([quizBlockMapper])
